import AudioCtrl from '@component/audio-ctrl/AudioCtrl';
import VideoCtrl from '@component/video-ctrl/VideoCtrl';
import AttendeeCtrl from '@component/attendee-ctrl';
import Invite from '@component/invite/Invite';
import './ControlZoom.css';
import LeaveControl from './leave-control';
import { isMobileBrowser } from '@utils/browser';

export default function ControlZoom() {
  return (
    <div className="control-zoom">
      <AudioCtrl />

      <VideoCtrl />
      <Invite />
      <AttendeeCtrl />
      {!isMobileBrowser() ? <LeaveControl /> : null}
    </div>
  );
}
